// Shows the full text as a tooltip when a fixed-width control or table cell cuts it
// with "…" (see "Language-independent sizing" in styles/app.css).
const SELECTOR = '.btn, .btn-outline, .dash-tab, .side-nav-item, table.emp-table th, table.emp-table td';

export function installOverflowTitles() {
  document.addEventListener('mouseover', (ev) => {
    const el = (ev.target as Element | null)?.closest<HTMLElement>(SELECTOR);
    if (!el) return;
    if (el.scrollWidth > el.clientWidth) {
      if (!el.title || el.dataset.autoTitle) { el.title = el.textContent?.trim() ?? ''; el.dataset.autoTitle = '1'; }
    } else if (el.dataset.autoTitle) {
      el.removeAttribute('title'); delete el.dataset.autoTitle;
    }
  });
}
